import type {IconType} from "react-icons";
import {FiActivity, FiAlertTriangle, FiInfo, FiTool, FiTrendingDown} from "react-icons/fi";

export const STATUS_ICON: Record<string, IconType> = {
  "major-outage": FiAlertTriangle,
  "partial-outage": FiAlertTriangle,
  "degraded-performance": FiTrendingDown,
  notification: FiInfo,
  "under-maintenance": FiTool,
  operational: FiActivity,
};
